/*
 * This file lists a series of fragments not related to any specific React
 * component, but necessary in various parts of the code.
 */

import ExternalVideoFragment from './external-video'
import ImageFragment from './image'
import LinkFragment from './link'
import MediaBlockFragment from './media-block'
import MediaBlockExternalFragment from './media-block-external'
import MenuItemFragment from './menu-item'
import { PageFragment, PageStaticParamsFragment } from './page'
import PageCardPreviewFragment from './page-card-preview'
import ParentTreeFragmentAllLocales from './parent-tree/all-locales'
import ParentTreeFragment from './parent-tree/simple'
import PartnerBlockFragment from './partner-block'
import RedirectLinkFragment from './redirect-link'
import ResponsiveImageFragment from './responsive-image'
import SectionPaddingFragment from './section-padding'
import SectionTextSideBlockFragment from './section-text-side-block'
import TagFragment from './tag'
import TeamMemberFragment from './team-member'
import VideoPlayerFragment from './video-player'

export {
  ExternalVideoFragment,
  ImageFragment,
  LinkFragment,
  MediaBlockExternalFragment,
  MediaBlockFragment,
  MenuItemFragment,
  PageCardPreviewFragment,
  PageFragment,
  PageStaticParamsFragment,
  ParentTreeFragment,
  ParentTreeFragmentAllLocales,
  PartnerBlockFragment,
  RedirectLinkFragment,
  ResponsiveImageFragment,
  SectionPaddingFragment,
  SectionTextSideBlockFragment,
  TagFragment,
  TeamMemberFragment,
  VideoPlayerFragment
}
